'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadata = require('./metadata');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _metadata.getCountryCallingCode;
  }
});
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/build/getCountryCallingCode.js
// module id = 175
// module chunks = 2